import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import FAQSearch from '../FAQSearch';
import Link from '../../../Core/Link';

export const StyledContainer = styled(Container)`
  font-size: 14px;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 16px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    font-size: 18px;
  }
`;

export const StyledFAQSearch = styled(FAQSearch)`
  margin: auto;
  max-width: 315px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 500px;
  }
`;

export const NavBar = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 56px 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 56px 0;
  }
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  line-height: 130%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.5rem;
    line-height: 130%;
  }
`;

export const Subheading = styled.div`
  margin: 40px 0 24px;
`;

export const Section = styled.div`
  width: 100%;
  background-color: ${themeGet('colors.white')};
  padding: 0.9375rem;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 2.25rem;
  }

  @media only screen and (min-width: 415px) {
    padding: 3.5rem;
  }

  .chartArea {
    width: 100%;
  }

  h4,
  h5 {
    font-size: inherit;
  }

  span.bold {
    font-weight: 600;
    color: ${themeGet('colors.black')};
  }
`;

export const StyledParagraph = styled.p`
  margin: 40px 0 24px;

  b,
  strong {
    font-weight: ${themeGet('fontWeights.medium')};
  }
`;

export const Ulist = styled.ul`
  text-align: left;
  margin-left: 32px;
  li {
    margin: 16px 0;
    font-size: 24px;
    font-weight: ${themeGet('fontWeights.medium')};
    p {
      margin: unset;
      font-size: 14px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      p {
        font-size: 16px;
      }
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      p {
        font-size: 18px;
      }
    }
  }

  p {
    font-size: 18px;
    font-weight: ${themeGet('fontWeights.normal')};
  }
`;

export const Olist = styled.ol`
  text-align: left;

  li {
    margin: 16px 0;
    font-size: 24px;
    font-weight: ${themeGet('fontWeights.medium')};
    p {
      margin: unset;
      font-size: 14px;
    }
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 16px;
      p {
        font-size: 16px;
      }
    }
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 18px;
      p {
        font-size: 18px;
      }
    }
  }

  p {
    font-size: 14px;
    font-weight: ${themeGet('fontWeights.normal')};
  }
`;

export const StyledLink = styled(Link)`
  margin: 2rem 2rem 0;
  svg {
    display: none;
  }
`;
